var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen d-flex justify-center align-center"},[_c('LoginForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }